import React, { Component } from 'react'
import Stepper from 'bs-stepper'

export default class stepper extends Component {

  componentDidMount() {
    // config stepper
    var steppersList = document.getElementsByClassName('bs-stepper');
    var stepper = new Stepper(steppersList[0], {
      linear: true,
      animation: true
    });
    // update step
    stepper.to(this.props.step);

    // detect screen resize
    window.addEventListener('resize', this.updateStepper);

    // if mobile or tablet, horizontal stepper
    if (window.innerWidth <= 768) {
        var mobileStepper = document.querySelector('.bs-stepper');
        mobileStepper.classList.remove("vertical");
    }
  }

  // change stepper's display on resize
  updateStepper = () => {
    var mobileStepper = document.querySelector('.bs-stepper');
    if (window.innerWidth <= 991) {
        mobileStepper.classList.remove("vertical");
    } else {
        mobileStepper.classList.add("vertical");
    }
  };


  render() {
    const { t } = this.props;
    
    return (
        <div>
            <div className="bs-stepper vertical" id="stepper">
                <div className="bs-stepper-header" role="tablist">
                    <div className="step" data-target="#logins-part">
                        <button type="button" className="step-trigger" role="tab" aria-controls="logins-part" id="logins-part-trigger">
                            <span className="bs-stepper-circle">1</span>
                            <span className="bs-stepper-label">{t("stepper.step1")}</span>
                        </button>
                    </div>
                    <div className="line"></div>
                    <div className="step" data-target="#information-part">
                        <button type="button" className="step-trigger" role="tab" aria-controls="information-part" id="information-part-trigger">
                            <span className="bs-stepper-circle">2</span>
                            <span className="bs-stepper-label">{t("stepper.step2")}</span>
                        </button>
                    </div>
                    <div className="line"></div>
                    <div className="step" data-target="#information-part">
                        <button type="button" className="step-trigger" role="tab" aria-controls="information-part" id="information-part-trigger">
                            <span className="bs-stepper-circle">3</span>
                            <span className="bs-stepper-label">{t("stepper.step3")}</span>
                        </button>
                    </div>
                    <div className="line"></div>
                    <div className="step" data-target="#information-part">
                        <button type="button" className="step-trigger" role="tab" aria-controls="information-part" id="information-part-trigger">
                            <span className="bs-stepper-circle">4</span>
                            <span className="bs-stepper-label">{t("stepper.step4")}</span>
                        </button>
                    </div>
                    <div className="line"></div>
                    <div className="step" data-target="#information-part">
                        <button type="button" className="step-trigger" role="tab" aria-controls="information-part" id="information-part-trigger">
                            <span className="bs-stepper-circle">5</span>
                            <span className="bs-stepper-label">{t("stepper.step5")}</span>
                        </button>
                    </div>
                </div>
                <div className="bs-stepper-content">
                    <div id="logins-part" className="content" role="tabpanel" aria-labelledby="logins-part-trigger"></div>
                    <div id="information-part" className="content" role="tabpanel" aria-labelledby="information-part-trigger"></div>
                </div>
            </div>
        </div>
    )
  }
}
